import React from 'react'
import { useTranslation } from 'react-i18next'
import styled, { keyframes } from 'styled-components'

export const VideoListLoadMoreLoader = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <Container role='status' aria-live='polite' aria-label={t('videos.loadingMore')}>
      <Dots aria-hidden='true'>
        <Dot />
        <Dot />
        <Dot />
      </Dots>
      <Label>{t('videos.loadingMore')}</Label>
    </Container>
  )
}

export default VideoListLoadMoreLoader

const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.4;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px 0 16px;
`

const Dots = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.main.primary500};
  animation: ${bounce} 1.2s ease-in-out infinite;

  &:nth-child(2) {
    animation-delay: 0.15s;
  }

  &:nth-child(3) {
    animation-delay: 0.3s;
  }
`

const Label = styled.span`
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.1px;
  color: ${({ theme }) => theme.colors.main.grey600};
`
